import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, enhancedViewport } from '../../utils/animation';
import './AboutStory.scss';

const AboutStory = () => {
  const { t } = useTranslation('about');
  const paragraphs = t('story.paragraphs', { returnObjects: true });
  const timeline = t('story.timeline', { returnObjects: true });
  
  // OPTIMIZAT: Eliminat useAnimation() și useEffect() overhead - folosim whileInView direct
  return (
    <section className="about-story">
      <div className="container">
        <motion.h2
          className="about-story__title"
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
          variants={fadeInUp}
        >
          {t('story.title')}
        </motion.h2>
        <div className="about-story__content">
          <motion.div
            className="about-story__text"
            initial="hidden"
            whileInView="visible"
            viewport={enhancedViewport}
            variants={fadeInUp}
          >
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </motion.div>
          <div className="about-story__timeline">
            {timeline.map((item, index) => (
              <motion.div
                key={index}
                className="about-story__timeline-item"
                initial="hidden"
                whileInView="visible"
                viewport={enhancedViewport}
                variants={fadeInUp}
              >
                <div className="about-story__timeline-content">
                  <h3 className="about-story__timeline-year">{item.year}</h3>
                  <p>{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
